module.exports = __webpack_public_path__ + "img/icon-moon.062faca2.svg";